<template lang="pug">
    v-container( fluid grid-list-lg )
        CustomerSearch(
          v-model="showCustomerModal"
          ref="customerSearch"
          @customer:set="setCustomer"
          :slim="false"
          )
        v-dialog( v-model='showBranchOfficeModal' )
            v-card
                v-card-title.subheading.font-weight-medium.text-uppercase.primary.darken-4.white--text Seleccionar sucursal
                v-card-text.pa-0
                    v-list( two-line ).py-0
                        template( v-if='customerBranchOffices.length > 0' )
                            v-list-tile( ripple @click='setCustomerBranchOffice()' )
                                v-list-tile-avatar( color='grey' )
                                    v-icon( dark ) store
                                v-list-tile-content
                                    v-list-tile-title Todas
                                    v-list-tile-sub-title Todas las sucursales
                        template( v-for='customerBranchOffice in customerBranchOffices' )
                            v-list-tile( ripple @click='setCustomerBranchOffice(customerBranchOffice)' )
                                v-list-tile-avatar( color='grey' )
                                    v-icon( dark ) store
                                v-list-tile-content
                                    v-list-tile-title {{ customerBranchOffice.address }}
                                    v-list-tile-sub-title {{ customerBranchOffice.city }}
        //v-layout( row wrap )

            v-flex( xs12 md4 )
                v-card
                    v-list( class='pa-0' two-line )
                        v-subheader Cartola de movimiento
                        v-list-tile( class='success lighten-5' )
                            v-list-tile-content
                            v-list-tile-actions
                                v-btn( color='success' depressed @click='showCustomerModal = true' ) previsualizar &nbsp;
                                    v-icon search
                                v-btn( color='success' flat @click='showCustomerModal = true' ) descargar &nbsp;
                                    v-icon cloud_download
            v-flex( xs12 )
                v-card
                    v-subheader Deudas
                    v-data-table( color='grey lighten-5' :headers='headers' :items='[]' )

        v-stepper( v-model='step' vertical )
            //v-container( fluid )
                v-layout( row wrap )
                    v-flex( xs12 md6 )
                        v-card
                            v-subheader.|mary.white--text Cliente
                            v-card-text
                                v-chip( 
                                    :close='customer'
                                    :color='customer ? "primary white--text" : ""'
                                    label 
                                    @input.passive='customer = null; customerBranchOffice = null' 
                                    )
                                    v-avatar
                                        v-icon person
                                    span {{ customer ? customer.business_name : 'Haz clic en buscar cliente' }}
                                v-chip( 
                                    :close='customerBranchOffice' 
                                    :color='customerBranchOffice ? "primary white--text" : ""'
                                    label 
                                    @input.passive='customerBranchOffice = null' 
                                    )
                                    v-avatar
                                        v-icon store
                                    span {{ customerBranchOffice ? customerBranchOffice.address : 'Haz clic en buscar sucursal' }}
                    v-flex( xs12 md6 )
                        v-card
                            v-subheader.teal.white--text Deudas
                            v-card-text
                                template( v-if='invoicesSelected.length > 0' )
                                    template( v-for='invoice in invoicesSelected' )
                                        v-chip( 
                                            color='teal white--text'
                                            label 
                                        )
                                            v-avatar
                                                v-icon attach_money
                                            span Folio: {{ invoice.number }} - Deuda: ${{ invoice.balance | mixThousandSeparatorFormat }}
                                template( v-else )
                                    v-chip( label )
                                        v-avatar
                                            v-icon attach_money
                                        template( v-if='customerBranchOffice' )
                                            span {{ allInvoices.length === 0 ? 'Sin deudas' : 'Selecciona al menos una deuda' }}
                                        template( v-else-if='customer' )
                                            span Haz clic en buscar sucursal
                                        template( v-else )
                                            span Haz clic en buscar cliente


            v-layout(slot row wrap)
                v-flex.pl-4.pt-4(md12 v-show="customerBusinessName != ''")
                    span.subheading 1. Cliente seleccionado
                v-flex.pl-5(md12 v-show="customerBusinessName != ''")
                    v-chip(color='primary' text-color='white' close @input="step=1" @input.passive='showCustomerModal = true')
                        v-avatar
                            v-icon person
                        | {{customerRutFormat }} - {{customerBusinessName}}
                    v-chip(color='primary darken-2' text-color='white' v-if='customerBranchOffice')
                        v-avatar
                            v-icon store
                        span( v-if='customerBranchOffice.id' ) {{ customerBranchOffice.address }} - {{ customerBranchOffice.city }}
                        span Todas
                v-flex.pl-4.mb-2(md12 v-show="step==3")
                    span.subheading 2. Deudas seleccionadas
                v-flex.pl-5(md3 v-show="step==3" v-for="item in invoicesSelected")
                    v-chip(color='teal' text-color='white')
                        | Folio : {{item.number}} / Deuda : ${{item.balance | mixThousandSeparatorFormat}}
                //v-flex.pa-4(md12)
                    v-divider
            v-stepper-step(:complete='step > 1' step='1') Seleccionar cliente{{ customer ? `: ${customer.business_name}` : '' }}

            v-stepper-content(step='1')
                v-card.elevation-0
                    v-btn( 
                        color='primary' 
                        @click='showCustomerModal = !showCustomerModal' 
                        ) buscar cliente &nbsp;
                            v-icon search
                    v-btn( 
                        color='primary' 
                        :disabled='!customer' 
                        @click='showBranchOfficeModal = !showBranchOfficeModal' 
                        ) buscar sucursal &nbsp;
                            v-icon search
            v-stepper-step(:complete='step > 2' step='2') Seleccionar deudas
            v-stepper-content(step='2')
                v-card.mb-5( )
                    invoice-table(v-if="step === 2" :items="allInvoices" :headers="headers" @invoiceSelected="invoiceSelected" ref="invoiceTableRef")
                    v-card-actions.pa-5
                        v-btn.white--text( color="orange accent-2" @click='goBeforeStep' @click.passive='showCustomerModal = true') Volver a Buscar Cliente
                        v-btn.mr-5(color='primary' @click.native='step = 3' :disabled="!allowPayButton") Pagar Documento
                        v-spacer
                        v-btn.ml-5(color='primary' @click='modal=true' ) ver cartola de movimiento
                        v-btn.ml-5(color='success'  @click="activeMovementsDownloadModal = true") 
                            | Descargar Cartola Movimiento
                            v-icon(right dark) cloud_download
                        v-dialog(v-model="activeMovementsDownloadModal")
                            v-toolbar.primary(dark)
                                span.title Descargar Cartola de Movimientos
                            v-card.pa-3
                                v-layout(wrap)
                                    v-flex.xs6.px3
                                        label Desde
                                        DateField(
                                            v-model="downloadMovementsFrom"
                                            outline
                                            )
                                    v-flex.xs6.px-3
                                        label Hasta
                                        DateField(
                                            v-model="downloadMovementsTo"
                                            outline
                                            )
                                    v-flex.xs12 
                                        v-btn.success(
                                            block
                                            @click="downloadDebts"
                                            )
                                            | Descargar Cartola Movimiento
                                            v-icon(right dark) cloud_download
                
            v-stepper-step(:complete='step > 3' step='3') Pago Documento
            v-stepper-content(step='3')
                v-card.mb-5()
                    payment( 
                        :copies='withCopy ? 2 : 1'
                        :saleCreditNotes='saleCreditNotes' 
                        @goback='gobackPayment' 
                        @success='successPayment' 
                        )
                    v-switch( 
                        :disabled='step < 3' 
                        class='mx-4' 
                        label='Generar comprobante con copia' 
                        style='display:inline-flex;' 
                        v-model='withCopy'
                        )
        v-dialog( content-class='primary darken-4' fullscreen v-model='modal' )
            v-toolbar( color='primary darken-4' dark flat )
                v-toolbar-title Cartola de movimientos
                v-spacer
                v-btn( icon @click='modal = false' )
                    v-icon close
            v-container( fluid py-2 )
                v-layout( wrap )
                    v-flex( xs12 )
                        v-card.px-4.pt-4
                            r-table( 
                                card
                                color='primary'
                                no-data-text='No se ha encontrado ninguna deuda.'
                                toolbar-color='primary'
                                toolbar-dark
                                toolbar-dense
                                toolbar-title='Deudas del proximo mes'
                                no-actions 
                                no-helper 
                                no-filter 
                                no-search 
                                v-bind='tablePropsNextMonth' 
                                )
                            br
                            r-table( 
                                card
                                color='primary'
                                toolbar-color='primary'
                                toolbar-dark
                                toolbar-dense
                                toolbar-title='Deudas pendientes'
                                no-actions 
                                no-helper 
                                no-filter 
                                no-search
                                v-bind='tableProps' 
                                )
                            br
                            r-table( 
                                card
                                color='primary'
                                no-data-text='No se ha encontrado ninguna nota de credito.'
                                toolbar-color='primary'
                                toolbar-dark
                                toolbar-dense
                                toolbar-title='Notas de credito'
                                no-actions 
                                no-helper 
                                no-filter 
                                no-search 
                                :headers='headersNote' 
                                v-bind='tablePropsCreditNote' 
                                )
                            br
                            r-table( 
                                card
                                color='primary'
                                toolbar-color='primary'
                                toolbar-dark
                                toolbar-dense
                                toolbar-title='Movimientos del mes'
                                no-actions 
                                no-helper 
                                no-filter 
                                no-search
                                :headers='headers3' 
                                v-bind='tablePropsCurrentMonth' 
                                )
</template>

<script>
/* components */
import InvoiceTable from './table/invoiceTable'
import { CrudForm, RUTInput } from '@/components/reusable_components'
import { RTable } from '@/components/reusable_components/next'
import formFields from './form/fields.js'
import Payment from './payment/PaymentMain'
/* services */
import CustomerPayment from '@/services/API/customerPayment'
import SaleCreditNoteModel from '@/models/Sale/SlSaleCreditNote'
import CustomerReceivablePaymentModel from '@/models/POS/PosCustomerReceivablePayment'
import CustomerAccountReceivableModel from '@/models/Sale/SlCustomerAccountReceivable'
import CustomerAccountReceivablePendingModel from '@/models/Sale/SlCustomerAccountReceivablePending'
import CustomerService from '@/services/API/CustomerService'
/* vuex */
import { mapActions, mapState } from 'vuex'
/* utils */
import { addRUTHyphen } from '@/services/RUTFormatter.js'
import moment from 'moment'
/* mixins */
import TextFormatting from '@/mixins/reusable_mixins/TextFormatting'
import RUTUtils from '../../mixins/reusable_mixins/RUTUtils'
import SlCustomer from '../../models/Sale/SlCustomer'
import CustomerSearch from '../../components/CustomerSearch/CustomerSearch'
import axios from 'axios'
import DateField from '../../components/reusable_components/next/DateField'

const initialState = () => ({
    modal: false,
    headers2: [
        { text: 'fecha deuda', value: 'pay_date', format: 'date' },
        { text: 'fecha emision', value: 'created_at', format: 'date' },
        { text: 'folio', value: 'number' },
        { text: 'tipo', value: 'document' },
        { text: 'monto', value: 'amount', format: 'currency' },
        { text: 'abonado', value: 'amount_paid', format: 'currency' },
        { text: 'saldo', value: 'receivable', format: 'currency' },
    ],
    headers3: [
        { text: 'codigo', value: 'id', width: '10%' },
        { text: 'fecha pago', value: 'created_at', format: 'date' },
        {
            text: 'total pago',
            value: 'total',
            format: 'currency',
            width: '10%',
        },
        { text: 'documentos pagados', value: 'payments_documents' },
        { text: 'medios de pago', value: 'payments_types' },
    ],
    headersNote: [
        /*FECHA EMISION FOLIO TOTAL REF. FOLIO REF. MOTIVO*/
        { text: 'emision', value: 'emission_date' },
        { text: 'folio', value: 'number' },
        { text: 'total', value: 'total' },
        //{ text: 'motivo',  },
    ],
    items: [{}],
    showBranchOfficeModal: false,
    showCustomerModal: true,
    name: '',
    customerBranchOffice: null,
    customerId: null,
    customerRut: '',
    customerRutFormat: '',
    customerBusinessName: '',
    step: 1,
    user: '',
    fields: formFields,
    customForm: {
        submitText: 'Buscar Cliente',
    },
    allInvoices: [],
    headers: [
        {
            text: 'Fecha Emisión',
            align: 'left',
            value: 'emission_date',
        },
        { text: 'Folio', value: 'number' },
        { text: 'Tipo', value: 'dte_type_invoice' },
        { text: 'Deuda', value: 'balance' },
        { text: 'Vencimiento', value: 'pay_date' },
    ],
    customerBranchOffices: [],
    saleCreditNotes: [],
    selectedInvoice: null,
    allowPayButton: false,
    customer: null,
    withCopy: false,
    activeMovementsDownloadModal: false,
    downloadMovementsFrom: null,
    downloadMovementsTo: null,
})

export default {
    name: 'customer-payment',
    props: {},
    data: () => initialState(),
    computed: {
        ...mapState('CustomerPaymentModule', {
            currentStep: state => state.currentStep,
            invoicesSelected: state => state.invoiceSelected,
        }),

        tablePropsCreditNote() {
            var date = new Date()
            var month = date.getMonth()
            var year = date.getFullYear()
            var monthNext = month < 11 ? month + 1 : 0
            var yearNext = month < 11 ? year : year + 1
            var firstDay = new Date(year, month, 1)
            var lastDay = new Date(yearNext, monthNext, 0)
            return {
                paramFilter: {
                    sl_customer_id: this.customer
                        ? this.customer.sl_customer_account_id
                        : null,
                    emission_date_min: firstDay
                        .toLocaleString()
                        .split(' ')
                        .shift()
                        .split('/')
                        .join('-')
                        .split('-')
                        .reverse()
                        .join('-'),
                    emission_date_max: lastDay
                        .toLocaleString()
                        .split(' ')
                        .shift()
                        .split('/')
                        .join('-')
                        .split('-')
                        .reverse()
                        .join('-'),
                },
                rowsPerPage: 10,
                service: SaleCreditNoteModel,
            }
        },

        tablePropsCurrentMonth() {
            var date = new Date()
            var month = date.getMonth()
            var year = date.getFullYear()
            var monthNext = month < 11 ? month + 1 : 0
            var yearNext = month < 11 ? year : year + 1
            var firstDay = new Date(year, month, 1)
            var lastDay = new Date(yearNext, monthNext, 0)
            return {
                filters: this.filters,
                headers: this.headers2,
                paramFilter: {
                    sl_customer_id: this.customer
                        ? this.customer.sl_customer_account_id
                        : null,
                    updated_at_min: firstDay
                        .toLocaleString()
                        .split(' ')
                        .shift()
                        .split('/')
                        .join('-')
                        .split('-')
                        .reverse()
                        .join('-'),
                    updated_at_max: lastDay
                        .toLocaleString()
                        .split(' ')
                        .shift()
                        .split('/')
                        .join('-')
                        .split('-')
                        .reverse()
                        .join('-'),
                },
                rowsPerPage: 10,
                service: CustomerReceivablePaymentModel,
            }
        },

        tablePropsNextMonth() {
            var date = new Date()
            var month = date.getMonth()
            var year = date.getFullYear()
            var monthNext = month < 11 ? month + 1 : 0
            var yearNext = month < 11 ? year : year + 1
            var monthNextNext = monthNext < 11 ? monthNext + 1 : 0
            var yearNextNext = monthNext < 11 ? year : year + 1
            var firstDay = new Date(yearNext, monthNext, 1)
            var lastDay = new Date(yearNextNext, monthNextNext, 0)
            return {
                filters: this.filters,
                headers: this.headers2,
                paramFilter: {
                    sl_customer_id: this.customer
                        ? this.customer.sl_customer_account_id
                        : null,
                    pay_date_min: firstDay
                        .toLocaleString()
                        .split(' ')
                        .shift()
                        .split('/')
                        .join('-')
                        .split('-')
                        .reverse()
                        .join('-'),
                    pay_date_max: lastDay
                        .toLocaleString()
                        .split(' ')
                        .shift()
                        .split('/')
                        .join('-')
                        .split('-')
                        .reverse()
                        .join('-'),
                },
                rowsPerPage: 10,
                service: CustomerAccountReceivablePendingModel,
            }
        },

        tableProps() {
            return {
                filters: this.filters,
                headers: this.headers2,
                service: CustomerAccountReceivablePendingModel,
                paramFilter: {
                    sl_customer_id: this.customer
                        ? this.customer.sl_customer_account_id
                        : null,
                },
                rowsPerPage: 10,
            }
        },
    },
    methods: {
        /**
         *
         */
        ...mapActions('CustomerPaymentModule', {
            setPaymentAmount: 'setPaymentAmount',
            setInvoice: 'setInvoice',
            setStep: 'setStep',
            clearArrayPayments: 'clearArrayPayments',
            clearPayment: 'clearPayment',
            clearInvoiceSelected: 'clearInvoiceSelected',
        }),
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        /**
         *
         */
        async submitForm(formData) {
            const rut = addRUTHyphen(this.customerRut)
            const name = String(this.name)
            this.customerRutFormat = rut
            console.log(rut, 'submitform')
            //
            this.showSnackWaiting()
            //)

            let customer =
                name.length > 0
                    ? await this.getCustomerByName(name)
                    : await this.fetchCustomer(rut)
            if (customer.id === undefined) {
                this.resetSnackbarState()
                this.initSnackbar(
                    this.fillSnack(
                        'warning',
                        'Rut no encontrado',
                        'El rut buscado no se encuentra en sistema'
                    )
                )
            } else {
                this.customerId = customer.id
                this.setCustomerBusinessName(customer)
                let response = await this.fetchDebtDocuments(customer)
                //
                this.allInvoices = response.data.data.map(d => {
                    let doc = d.sl_sale_invoice || d.sl_sale_debit_note || {}
                    doc.document = d.document
                    doc.receivable = d.receivable
                    doc.pay_date = d.pay_date
                    doc.id = d.id
                    return doc
                })
                console.log(this.allInvoices)
                this.resetSnackbarState()
                this.goStep(2)
            }
        },
        fetchCustomer(rut) {
            return new SlCustomer().where('rut', rut).first()
        },
        getCustomerByName(name) {
            return SlCustomer.where('business_name', name).first()
        },
        fetchDebtDocuments(customer) {
            const route =
                process.env.VUE_APP_API_ROUTE +
                '/sl_customer_account_receivable_pending' +
                `?filter[sl_customer_account_id]=${
                    customer.sl_customer_account_id
                }` +
                `&filter[sl_customer_branch_offices_id]=${
                    customerBranchOffice.id
                }` +
                '&include=sl_sale_invoice,sl_sale_debit_note'
            return axios.get(route, {
                params: {
                    get_all_results: true,
                },
            })
        },
        /**
         *
         */
        formatData(data) {
            let formData = data
            formData = this.formatDate(formData)
            formData = this.formatTotal(formData)
            formData = this.formatTypeDocument(formData)
            formData = this.formatTotalForPay(formData)
            return formData
        },
        /**
         *
         */
        formatTotalForPay(data) {
            console.log({ data })
            return data.map(invoice => {
                let auxInvoice = { ...invoice }
                auxInvoice.balance = invoice.account_receivable.balance || 0
                return auxInvoice
            })
        },
        /**
         *
         */
        formatDate(data) {
            return data.map(invoice => {
                invoice.emission_date = moment(invoice.emission_date).format(
                    'DD-MM-YYYY'
                )
                return invoice
            })
        },
        /**
         *
         */
        formatTotal(data) {
            return data.map(invoice => {
                invoice.total = parseFloat(invoice.total)
                return invoice
            })
        },
        /*
         */
        getObjectKeyRut(rut) {
            let newObjRut = {}
            newObjRut.field = 'rut'
            newObjRut.value = rut
            return newObjRut
        },
        /**
         *
         */
        formatTypeDocument(data) {
            return data.map(invoice => {
                switch (invoice.dte_type_invoice) {
                    case 33:
                        invoice.dte_type_invoice = 'Factura Electrónica'
                        return invoice
                        break
                    case 34:
                        invoice.dte_type_invoice = 'Factura Exenta Electrónica'
                        return invoice
                        break
                    case 39:
                        invoice.dte_type_invoice = 'Boleta'
                        return invoice
                        break
                    default:
                        invoice.dte_type_invoice = invoice.dte_type_invoice
                        return invoice
                        break
                }
            })
        },
        /**
         *
         */
        showSnackWaiting() {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack('info', 'Buscando...', 'Espere un momento', true)
            )
        },
        /**
         *
         */
        showResponse(response) {
            if (response.data.length > 0) {
                //this.successResponse()
                this.resetSnackbarState()
                return 'success'
            } else if (response.data.length === 0) {
                this.warningResponse('No se encontraron deudas.')
                return 'warning'
            } else if (response.status == 'error') {
                this.errorResponse(response.message)
                return 'error'
            }
        },
        /**
         *
         */
        successResponse() {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'Cliente Encontrado 32323232',
                    false,
                    3600
                )
            )
        },
        /**
         *
         */
        errorResponse(message) {
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('error', 'Error', message))
        },
        /**
         *
         */
        warningResponse(message) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack('warning', 'Rut sin deudas', message)
            )
        },
        /**
         *
         */
        goStep(number) {
            console.log('NEW STEP', number)
            this.step = number
        },
        /**
         *
         */
        invoiceSelected(event) {
            event.forEach(item => {
                item.balance = item.receivable
            })
            //event.balance = event.account_receivable.balance
            this.setPaymentAmount(event)
            this.setInvoice(event)
            this.allowPayButton = event.length > 0
        },
        /**
         *
         */
        goBeforeStep() {
            this.goStep(1)
            this.clearArrayPayments()
            this.clearPayment()
            this.cleanRut()
            this.showCustomerModal = true
        },
        /**
         *
         */
        SearchCustomer() {
            // this.$refs.formRut.submitForm()
        },
        /**
         *
         */
        cleanRut() {
            this.customerRut = ''
            this.customerRutFormat = ''
            this.customerBusinessName = ''
            //his.step = 1
            this.$refs.rutInput.rut = ''
            this.clearArrayPayments()
            this.clearPayment()
        },
        /*
         */
        setCustomerBusinessName(customer) {
            if (customer) this.customerBusinessName = customer.business_name
        },
        async setCustomerBranchOffice(customerBranchOffice = {}) {
            //
            this.customerBranchOffice = customerBranchOffice
            this.showBranchOfficeModal = false
            //
            this.showSnackWaiting()
            //
            await this.getPendingDebts()
                .then(this.setPendingDebts)
                .then(this.getCreditNotes)
                .then(this.setCreditNotes)
            //
            this.clearInvoiceSelected()
            this.goStep(2)
        },
        /*
         *
         */
        downloadDebts() {
            CustomerPayment.downloadPdf(
                this.customerId,
                this.customerRutFormat,
                this.downloadMovementsFrom,
                this.downloadMovementsTo
            )
        },
        getCreditNotes() {
            return SaleCreditNoteModel.where('sl_customer_id', this.customer.id)
                .where('used_for_payment', false)
                .limit(-1)
                .get()
        },
        setCreditNotes(res) {
            this.saleCreditNotes = res.data
        },
        getPendingDebts() {
            return CustomerAccountReceivablePendingModel.include(
                'sl_sale_invoice',
                'sl_sale_debit_note'
            )
                .where(
                    'sl_customer_account_id',
                    this.customer.sl_customer_account_id
                )
                .where(
                    'sl_customer_branch_offices_id',
                    this.customerBranchOffice.id || ''
                )
                .limit(-1)
                .get()
        },
        mapPendingDebts(item) {
            //
            let itemDocument =
                item.sl_sale_invoice || item.sl_sale_debit_note || {}
            //
            itemDocument['document'] = item.document
            itemDocument['receivable'] = item.receivable
            itemDocument['pay_date'] = item.pay_date
            itemDocument['id'] = item.id
            itemDocument['pay_date'] = item.pay_date
            //
            return itemDocument
        },
        setPendingDebts(res) {
            //
            this.allInvoices = res.data.map(this.mapPendingDebts)
            //
            this.showResponse(res)
            //if (this.allInvoices.length < 1) this.errorResponse('No se encontraron deudas para este cliente')
        },
        async setCustomer(customer) {
            this.customer = customer
            this.customerRutFormat = customer.rut
            this.customerId = customer.id
            this.setCustomerBusinessName(customer)
            //
            this.customerBranchOffice = null
            this.customerBranchOffices = customer.branch_offices
            this.showBranchOfficeModal = true
            //
            /*let response = null
            try {
                response = await this.fetchDebtDocuments(customer)
            } catch (e) {
                if (e && e.response && e.response.data) {
                    if (
                        e.response.data.error &&
                        e.response.data.error.includes('does not exist')
                    )
                        return this.errorResponse(
                            'No se encontraron deudas para este cliente'
                        )
                    else if (e.response.data.message)
                        return this.errorResponse(e.response.data.message)
                    else return this.errorResponse(e)
                } else return this.errorResponse('Ha ocurrido un error')
            }
            if (!response) return
            //
            this.allInvoices = response.data.data.map(d => {
                let doc = d.sl_sale_invoice || d.sl_sale_debit_note || {}
                doc.document = d.document
                doc.receivable = d.receivable
                doc.pay_date = d.pay_date
                doc.id = d.id
                return doc
            })

            SaleCreditNoteModel
                .where('sl_customer_id', customer.id)
                .where('used_for_payment', false)
                .limit(-1)
                .get()
                .then(res => {
                    this.saleCreditNotes = res.data
                })*/

            this.resetSnackbarState()
        },
        gobackPayment() {
            this.goStep(2)
        },
        successPayment() {
            console.log('success payment')
            Object.assign(this.$data, initialState())
            // this.goStep(1)
            // this.$refs.invoiceTableRef.cleanSelectedItems()
            //this.submitForm()
            // this.clearInvoiceSelected()
            // this.allInvoices = []
            // this.goStep(1)
            // this.getPendingDebts()
            //     .then(this.setPendingDebts)
            //     .then(this.getCreditNotes)
            //     .then(this.setCreditNotes)
            //     .
            // this.goStep(2)
            //this.$refs.invoiceTableRef.cleanSelectedItems()
        },
    },
    watch: {
        async step(value) {
            if (value === 1) {
                // this.cleanRut()
                this.$refs.invoiceTableRef.cleanSelectedItems()
                this.clearInvoiceSelected()
            }

            //this.setStep(value)
            if (value === 2) {
                console.log('in watch step 2')
                let response = await this.fetchDebtDocuments(this.customer)
                this.allInvoices = response.data.data.map(d => {
                    let doc = d.sl_sale_invoice || d.sl_sale_debit_note || {}
                    doc.document = d.document
                    doc.receivable = d.receivable
                    doc.pay_date = d.pay_date
                    doc.id = d.id
                    return doc
                })
                this.$refs.invoiceTableRef.cleanSelectedItems()
            }
            if (value === 3) {
                console.log('STEP 3')
                this.$nextTick(() => {
                    if (document.getElementById('payment-method'))
                        document.getElementById('payment-method').focus()
                })
            }
        },
        currentStep(currentStep) {
            //console.log(currentStep, 'currentStepFROMstepers')
            if (currentStep != this.step) {
                this.step = currentStep
            }
        },
        customerBranchOffice(value) {
            if (!value) this.goStep(1)
        },
    },
    components: {
        CrudForm,
        InvoiceTable,
        Payment,
        RUTInput,
        CustomerSearch,
        RTable,
        DateField,
    },
    mixins: [TextFormatting, RUTUtils],
    filters: {},
}
</script>

<style lang="scss"></style>
